/* eslint-disable
    import/default,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import { RequestContentType, getAuthorizationHeader } from 'utils/Helpers'
import * as ResourcesConstants from 'constants/ResourcesConstants'

const OrgPropertiesAPI = Marty.createStateSource({
  id: 'OrgPropertiesAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CUSTOMER_API,

  fetchProperties(orgId) {
    return this.get({
      url: `/organizations/${ orgId }/properties`,
      headers: getAuthorizationHeader()
    })
  },

  updateProperties(orgId, properties) {
    return this.patch({
      url: `/organizations/${ orgId }/properties`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(properties)
    })
  },

  /**
   * Uploads a file associated with an organization
   * @param { number } orgId - the organization's ID
   * @param { File } file - an file to upload
   */
  uploadOrgImage(orgId, file) {
    const data = new FormData()
    data.append('file', file)
    return this.post({
      url: `/organizations/${ orgId }/attachments`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.FORM_DATA,
      body: data
    })
  }
})

export default OrgPropertiesAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/OrgPropertiesAPI.js